import { useEffect, useState } from "react";
import { Button, Col, Dropdown, DropdownButton, Form, Row } from "react-bootstrap";
import { defineValueInInput } from "../../../../components/funcForInput";
import LoadingModal from "../../../../components/loadingModal";
import { ApiEndpoints, reqPostNew } from "../../../../config/apiClient";
import { getUrlSearchParams } from "../../../urlParams";
import Escala12x36Form from "./Escala12x36Form";
import EscalaFlexivelForm from "./EscalaFlexivelForm";
import EscalaNormalForm from "./EscalaNormalForm";

export default function EscalasFormPage() {
    useEffect(() => {
        document.title = `Cadastrar Escala | OB PORTUS`;
        carregarDados();
    }, []);

    const [escala, setEscala] = useState<any>({});
    const [loading, setLoading] = useState<boolean>(false);
    const [tipoEscala, setTipoEscala] = useState<any>({
        id_tipo: 0,
        descricao: "Selecionar Opção",
    });

    async function carregarDados() {
        const url = getUrlSearchParams();
        let id_escala = url.get("id");
        if (id_escala === null) {
            return;
        }
        let dados = {
            id_escala: Number(id_escala),
        };
        setLoading(true);
        const api = await reqPostNew(ApiEndpoints.pontoEscalaConsultar, dados);
        setLoading(false);
        if (api.status === 200) {
            const escalaDados = api.data;
            setEscala(escalaDados);
            document.title = `Editar Escala | OB PORTUS`;
            document.getElementById("titleMain")!.innerText = `Editar Escala`
            defineValueInInput("codigo", escalaDados.codigo);
            defineValueInInput("descricao", escalaDados.descricao);
            let tipoEscala = "Escala Normal";
            if (escalaDados.id_tipo === 2) {
                tipoEscala = "Escala 12x36";
            }
            if (escalaDados.id_tipo === 3) {
                tipoEscala = "Escala Flexível";
            }
            setTipoEscala({ id_tipo: escalaDados.id_tipo, descricao: tipoEscala });
        }
    }

    function handleAlterarTipo(idx: number) {
        setTipoEscala(TIPOS_ESCALAS[idx]);
    }

    return (
        <div id="main">
            <LoadingModal show={loading} handleClose={() => {}} />
            <div className="div-row-space-between">
                <h1 id="titleMain" style={{ marginRight: "10px" }}>
                    Cadastrar Escala
                </h1>
                <Button
                    onClick={() => {
                        window.location.assign(`/ponto/escalas`);
                    }}
                >
                    Voltar
                </Button>
            </div>
            <br></br>
            <div>
                <Row className="mb-15-forms">
                    <Col className="col-2">
                        <Form.Group>
                            <Form.Label>Código:</Form.Label>
                            <Form.Control name="codigo" type="number" id="codigo" placeholder="" />
                            <Form.Control.Feedback type="invalid">Informe o código da escala!</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-7">
                        <Form.Group>
                            <Form.Label>Descrição:</Form.Label>
                            <Form.Control name="descricao" type="text" id="descricao" placeholder="" />
                            <Form.Control.Feedback type="invalid">Informe uma descrição para escala!</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-1">
                        <Form.Group>
                            <Form.Label>
                                <b>Tipo Escala:</b>
                            </Form.Label>
                            <DropdownButton id="id_tipo_escala" disabled={Object.values(escala).length > 0} title={tipoEscala.descricao}>
                                <Dropdown.Item onClick={() => handleAlterarTipo(0)}>Escala Normal</Dropdown.Item>
                                <Dropdown.Item onClick={() => handleAlterarTipo(1)}>Escala 12x36</Dropdown.Item>
                                <Dropdown.Item onClick={() => handleAlterarTipo(2)}>Escala Flexível</Dropdown.Item>
                            </DropdownButton>
                        </Form.Group>
                    </Col>
                </Row>
            </div>

            {tipoEscala.id_tipo === 1 && <EscalaNormalForm escala={escala} handleUpdate={undefined} />}
            {tipoEscala.id_tipo === 2 && <Escala12x36Form escala={escala} handleUpdate={undefined} />}
            {tipoEscala.id_tipo === 3 && <EscalaFlexivelForm escala={escala} handleUpdate={undefined} />}
        </div>
    );
}

const TIPOS_ESCALAS = [
    {
        id_tipo: 1,
        descricao: "Escala Normal",
    },
    {
        id_tipo: 2,
        descricao: "Escala 12x36",
    },
    {
        id_tipo: 3,
        descricao: "Escala Flexível",
    },
];
